import { Link, useLocation } from "react-router-dom";
import Menu from "../menu/Menu";
import { Ellipsis, X } from "lucide-react";

const MobileTable = ({ columns, data, link, button }) => {
  const location = useLocation();

  const list = [
    { id: 1, text: "Delete", type: "link" },
    { id: 2, text: "Details", type: "button" },
  ];

  return (
    <table className="table sm:hidden ">
      <tbody>
        {data.map((item, index) => {
          return (
            <tr key={index} className="bg-white">
              {columns.map((col, indexTwo) => {
                if (col.id === "num") {
                  return (
                    <td key={indexTwo} className="table-data-mobile">
                      <span className="thead-data">{col.text}:</span>
                      <span className="text-text-1/70">{++index}</span>
                    </td>
                  );
                } else if (col.id === "name" || col.id === "nice_name") {
                  // FInd Path
                  let path = `${location.pathname}/${item.id}`;
                  if (col.text === "Role") {
                    path = `/settings/permissions/${item.id}`;
                  } else if (location.pathname === "/project-requests") {
                    path = `/projects/${item.id}`;
                  }
                  //Find path end
                  return (
                    <td
                      key={indexTwo}
                      className={`table-data-mobile ${
                        button ? " cursor-pointer hover:text-primary" : ""
                      }`}
                      onClick={(e) =>
                        button ? button(true, item.id) : () => {}
                      }
                    >
                      <span className="thead-data">{col.text}:</span>

                      {link ? (
                        <Link
                          className="text-wrap text-primary hover:text-primary/75 text-right"
                          to={path}
                        >
                          <span className="text-text-1/70">{item[col.id]}</span>
                        </Link>
                      ) : (
                        <span className="text-text-1/70">{item[col.id]}</span>
                      )}
                    </td>
                  );
                } else if (col.id === "action") {
                  return (
                    <td key={indexTwo} className="table-data-mobile">
                      <span className="thead-data">Actions:</span>
                      <Menu
                        list={list}
                        firstIcon={<X size={20} className="menu-icon" />}
                        secondIcon={
                          <Ellipsis size={20} className="menu-icon" />
                        }
                      />
                    </td>
                  );
                } else if (col.id === "color") {
                  return (
                    <td key={indexTwo} className="table-data-mobile">
                      <span className="thead-data">{col.text}:</span>
                      <span
                        className="rounded-md px-6 py-2 text-text-1/70"
                        style={{ backgroundColor: item[col.id] }}
                      ></span>
                    </td>
                  );
                } else
                  return (
                    <td key={indexTwo} className="table-data-mobile">
                      <span className="thead-data">{col.text}:</span>
                      <span className="text-text-1/70">{item[col.id]}</span>
                    </td>
                  );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default MobileTable;
